import { z } from 'zod';

import { usuarioAtualSchema } from '@fiscoai/contracts';

import { request } from '../http';

export function buscarUsuarioAtual(signal?: AbortSignal) {
  return request('/auth/me', { schema: usuarioAtualSchema, ...(signal ? { signal } : {}) });
}

export function encerrarNoServidor() {
  return request('/auth/logout', { method: 'POST', schema: z.unknown(), auth: false });
}
